/* unplugin-vue-components disabled */import { render } from "./FooterPc.vue?vue&type=template&id=326bec41&scoped=true"
import script from "./FooterPc.vue?vue&type=script&lang=js"
export * from "./FooterPc.vue?vue&type=script&lang=js"

import "./FooterPc.vue?vue&type=style&index=0&id=326bec41&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326bec41"]])

export default __exports__